import { generateClient } from 'aws-amplify/api';
import { updateNotification } from "../graphql/mutations";

const client = generateClient();

export default async ({ id, userId, hasViewed, status, content, date, expiry }) => {
    const {
        data: { updateNotification: updatedNotification }
    } = await client.graphql({
        query: updateNotification,
        variables: {
            input: {
                id,
                userId,
                hasViewed,
                status,
                content,
                date,
                expiry
            },
        },
    });
    return updatedNotification;
};